<template lang="pug">
  .component-accordion-item.accordion-item(data-accordion-item="")
    a.accordion-title(href="#") {{ title }}
    .accordion-content(data-tab-content="")
      slot

</template>
<script type="text/babel">
  export default {
    name: "AccordionItem",
    components: {},
    data() {
      return {}
    },
    methods: {},
    props: ['title']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// AccordionItem.vue?28751661